import type { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const styles = {
  tile: (theme: Theme) => ({
    borderRadius: '0.5rem',
    height: '100%',
    boxShadow: `0 4px 23px 0 ${alpha(theme.colors.black, 0.2)}`,
  }),

  body: {
    cursor: 'pointer',
    height: '100%',
    minHeight: '25rem',
  },
};
